<template>
  <v-container fluid>
    <div>
      <!-- ヘッダー -->
      <v-row>
        <v-col cols="12">
          <h2>
            <v-icon class="mr-2">
              mdi-label-outline
            </v-icon>
            カスタム表示ラベル
          </h2>
          <v-spacer class="mt-2" />
        </v-col>
      </v-row>
      <!-- /ヘッダー -->
      <v-card
        flat
        class="rounded-card"
      >
        <v-card-text>
          <v-card flat class="rounded-card">
            <v-card-text>

              <!-- タイトル -->
              <v-row>
                <v-col cols="12" md="2">
                  <div class="overline">
                    タイトルの利用有無
                  </div>
                  <h4>{{ custom_label.use_title_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    タイトル
                  </div>
                  <h4>{{ custom_label.name_title }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <!-- ラベル１ -->
              <v-row>
                <v-col cols="12" md="2">
                  <div class="overline">
                    ラベル①の利用有無
                  </div>
                  <h4>{{ custom_label.custom_labels1_use_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    ラベル名
                  </div>
                  <h4>{{ custom_label.custom_labels1_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="1">
                  <div class="overline">
                    必須入力
                  </div>
                  <h4>{{ custom_label.custom_labels1_required_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    入力文字制御
                  </div>
                  <h4>{{ custom_label.custom_labels1_halfsize_alphanumeric_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最小入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels1_minimum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最大入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels1_maximum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /ラベル１ -->

              <!-- ラベル２ -->
              <v-row>
                <v-col cols="12" md="2">
                  <div class="overline">
                    ラベル②の利用有無
                  </div>
                  <h4>{{ custom_label.custom_labels2_use_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    ラベル名
                  </div>
                  <h4>{{ custom_label.custom_labels2_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="1">
                  <div class="overline">
                    必須入力
                  </div>
                  <h4>{{ custom_label.custom_labels2_required_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    入力文字制御
                  </div>
                  <h4>{{ custom_label.custom_labels2_halfsize_alphanumeric_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最小入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels2_minimum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最大入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels2_maximum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /ラベル２ -->

              <!-- ラベル３ -->
              <v-row>
                <v-col cols="12" md="2">
                  <div class="overline">
                    ラベル③の利用有無
                  </div>
                  <h4>{{ custom_label.custom_labels3_use_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    ラベル名
                  </div>
                  <h4>{{ custom_label.custom_labels3_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="1">
                  <div class="overline">
                    必須入力
                  </div>
                  <h4>{{ custom_label.custom_labels3_required_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    入力文字制御
                  </div>
                  <h4>{{ custom_label.custom_labels3_halfsize_alphanumeric_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最小入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels3_minimum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最大入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels3_maximum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /ラベル３ -->

              <!-- ラベル４ -->
              <v-row>
                <v-col cols="12" md="2">
                  <div class="overline">
                    ラベル④の利用有無
                  </div>
                  <h4>{{ custom_label.custom_labels4_use_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    ラベル名
                  </div>
                  <h4>{{ custom_label.custom_labels4_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="1">
                  <div class="overline">
                    必須入力
                  </div>
                  <h4>{{ custom_label.custom_labels4_required_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    入力文字制御
                  </div>
                  <h4>{{ custom_label.custom_labels4_halfsize_alphanumeric_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最小入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels4_minimum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最大入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels4_maximum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /ラベル４ -->

              <!-- ラベル５ -->
              <v-row>
                <v-col cols="12" md="2">
                  <div class="overline">
                    ラベル⑤の利用有無
                  </div>
                  <h4>{{ custom_label.custom_labels5_use_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    ラベル名
                  </div>
                  <h4>{{ custom_label.custom_labels5_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="1">
                  <div class="overline">
                    必須入力
                  </div>
                  <h4>{{ custom_label.custom_labels5_required_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    入力文字制御
                  </div>
                  <h4>{{ custom_label.custom_labels5_halfsize_alphanumeric_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最小入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels5_minimum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最大入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels5_maximum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /ラベル５ -->

              <!-- ラベル６ -->
              <v-row>
                <v-col cols="12" md="2">
                  <div class="overline">
                    ラベル⑥の利用有無
                  </div>
                  <h4>{{ custom_label.custom_labels6_use_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    ラベル名
                  </div>
                  <h4>{{ custom_label.custom_labels6_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="1">
                  <div class="overline">
                    必須入力
                  </div>
                  <h4>{{ custom_label.custom_labels6_required_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    入力文字制御
                  </div>
                  <h4>{{ custom_label.custom_labels6_halfsize_alphanumeric_name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最小入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels6_minimum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="2">
                  <div class="overline">
                    最大入力文字数
                  </div>
                  <h4 class="text-right">{{ custom_label.custom_labels6_maximum_characters }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /ラベル６ -->

            </v-card-text>
          </v-card>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="editButtonClickEvent"
            >
              編集
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'DriverCustomLabelForm',
  components: {
  },
  mixins: [],
  data () {
    return {
      custom_label: null,
    }
  },
  computed: {
  },
  created() {
    this.fetchCustomLabel().then((content) => {
      this.custom_label = content
    })
  },
  methods: {
    ...mapActions('DriverMasterCustomLabel', {
      fetchCustomLabel: 'show',
    }),
    editButtonClickEvent () {
      this.$router.push({name: 'DriverMasterCustomLabelEdit'})
    },
  }
}
</script>

<style scoped>

</style>
